import { TAB_KEYS_BY_PAGE } from "@/const/tab.constants"

export const OPEN_FILTERS_KEY = "open"

export const ENVIRONMENTS_FILTERS_KEY = "environments"

export const PRIORITY_FILTERS_KEY = "priorities"

export const TYPE_FILTERS_KEY = "categories"

export const IS_NEW_FILTERS_KEY = "isNew"

export const TAB_KEY = "tab"

export const INCIDENTS_TAB = TAB_KEYS_BY_PAGE.INCIDENTS[0]

export const DISMISSED_TAB = TAB_KEYS_BY_PAGE.INCIDENTS[1]
